export default __webpack_public_path__ + "static/media/aggregate_sl_results.d44fad96.png";